/*
  mock地址： http://mock.jdfmgt.com/interface/?projectId=62f5c111855696ad35fc3d4d
*/
export default [
  {
    /**
     * 立即开通
     * https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=6302fabeaf50ba51ae0c999b
     */
    name: 'applyOpenProduct',
    method: 'post',
    url: '/finhub/front/product/applyOpenProduct',
  },
  {
    /**
     * 统计活动数量
     * https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=632969a179621f424e8aeb5c
     */
    name: 'queryActiveProductNum',
    method: 'post',
    url: '/finhub/front/product/queryActiveProductNum',
  },

  {
    /**
     * 查询最新合同协议
     * https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=6302fabeaf50ba51ae0c999b
     */
    name: 'queryLatestContract',
    method: 'post',
    url: '/finhub/front/contract/queryLatestContract',
  },
]
